// extracted by mini-css-extract-plugin
export default {"wrapper":"Copy_wrapper__J58wK","text":"Copy_text__YJEne","copy":"Copy_copy__EJ8Z8","stroke":"Copy_stroke__Q-reO","checkIcon":"Copy_checkIcon__yWcF1"};